import React from "react";

import { Container } from "./styles";

const News: React.FC = () => {
  return (
    <Container>
      <span>Assuntos do momento no Brasil</span>
      <strong>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</strong>
    </Container>
  );
};

export default News;
